import { useState, createContext, useEffect } from "react";

export const SidebarContext = createContext({});

export function SidebarProvider({ children }) {
  const [selectedItem, setSelectedItem] = useState("home");

  const [isSubMenuFinanceiro, setIsSubMenuFinanceiro] = useState(false);
  const [isSubMenuSorteios, setIsSubMenuSorteios] = useState(false);
  const [isSubMenuConfiguracao, setIsSubMenuConfiguracao] = useState(false);
  const [isSubMenuCliente, setisSubMenuCliente] = useState(false);
  const [isSubMenuMarketing, setisSubMenuMarketing] = useState(false);
  const [isSubMenuSuporte, setisSubMenuSuporte] = useState(false);

  useEffect(() => {
    if (isSubMenuFinanceiro) {
      setIsSubMenuFinanceiro(true);
      setIsSubMenuSorteios(false);
      setIsSubMenuConfiguracao(false);
      setisSubMenuCliente(false);
      setisSubMenuMarketing(false);
      setisSubMenuSuporte(false);
    }

    if (isSubMenuSorteios) {
      setIsSubMenuFinanceiro(false);
      setIsSubMenuSorteios(true);
      setIsSubMenuConfiguracao(false);
      setisSubMenuCliente(false);
      setisSubMenuMarketing(false);
      setisSubMenuSuporte(false);
    }

    if (isSubMenuConfiguracao) {
      setIsSubMenuFinanceiro(false);
      setIsSubMenuSorteios(false);
      setIsSubMenuConfiguracao(true);
      setisSubMenuCliente(false);
      setisSubMenuMarketing(false);
      setisSubMenuSuporte(false);
    }

    if (isSubMenuCliente) {
      setIsSubMenuFinanceiro(false);
      setIsSubMenuSorteios(false);
      setIsSubMenuConfiguracao(false);
      setisSubMenuCliente(true);
      setisSubMenuMarketing(false);
      setisSubMenuSuporte(false);
    }

    if (isSubMenuMarketing) {
      setIsSubMenuFinanceiro(false);
      setIsSubMenuSorteios(false);
      setIsSubMenuConfiguracao(false);
      setisSubMenuCliente(false);
      setisSubMenuMarketing(true);
      setisSubMenuSuporte(false);
    }

    if (isSubMenuSuporte) {
      setIsSubMenuFinanceiro(false);
      setIsSubMenuSorteios(false);
      setIsSubMenuConfiguracao(false);
      setisSubMenuCliente(false);
      setisSubMenuMarketing(false);
      setisSubMenuSuporte(true);
    }
  }, [
    isSubMenuFinanceiro,
    isSubMenuSorteios,
    isSubMenuConfiguracao,
    isSubMenuCliente,
    isSubMenuMarketing,
    isSubMenuSuporte,
  ]);

  return (
    <SidebarContext.Provider
      value={{
        selectedItem,
        setSelectedItem,
        isSubMenuFinanceiro,
        setIsSubMenuFinanceiro,
        isSubMenuSorteios,
        setIsSubMenuSorteios,
        isSubMenuConfiguracao,
        setIsSubMenuConfiguracao,
        isSubMenuCliente,
        setisSubMenuCliente,
        isSubMenuMarketing,
        setisSubMenuMarketing,
        isSubMenuSuporte,
        setisSubMenuSuporte,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
}
